import { NeedsResourceDetailsDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum ResourcingEventTypes {
  RESOURCING_DETAILS_UPSERTED = '[Resourcing Details] Upserted',
}

/**
 * Payloads
 */
export interface ResourcingDetailsEventPayload {
  resourcingDetails: NeedsResourceDetailsDto;
}

/**
 * Events
 */
export class ResourceDetailsUpsertedEvent {
  readonly type = ResourcingEventTypes.RESOURCING_DETAILS_UPSERTED;

  constructor(public payload: ResourcingDetailsEventPayload) {}
}
